import React from 'react';

import { REGIONAL_DOMAINS_PARAMS, RegionalDomain } from './consts';
import { getRegionalDomainRedirectUrl } from './utils';
import { router } from './router';

const SUBDOMAIN_MATCHES = {
  'https://mf.novakidschool.com': 'https://school.novakidschool.com',
  'https://mf-c.novakidschool.com': 'https://c.novakidschool.com',
  'https://mf-qa.novakidschool.com': 'https://qa.novakidschool.com',
};

export const withRedirects = (App: React.ComponentType) => () => {
  if (window.location.origin in SUBDOMAIN_MATCHES) {
    window.location.replace(
      window.location.href.replace(
        window.location.origin,
        // @ts-ignore
        SUBDOMAIN_MATCHES[window.location.origin],
      )
    );

    return null;
  }

  if (window.location.host in REGIONAL_DOMAINS_PARAMS) {
    const url = getRegionalDomainRedirectUrl(
      router.state.location.search,
      window.location.host as RegionalDomain
    );

    window.location.replace(url);
    return null;
  }

  return <App />;
};
